import { render, staticRenderFns } from "./SalesIvaList.vue?vue&type=template&id=ba208306&scoped=true"
import script from "./SalesIvaList.vue?vue&type=script&lang=js"
export * from "./SalesIvaList.vue?vue&type=script&lang=js"
import style0 from "./SalesIvaList.vue?vue&type=style&index=0&id=ba208306&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba208306",
  null
  
)

export default component.exports